import { render, staticRenderFns } from "./ServicePlanner.vue?vue&type=template&id=8835acf0"
import script from "./ServicePlanner.vue?vue&type=script&lang=ts"
export * from "./ServicePlanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports